module.exports = __webpack_public_path__ + "img/bakery-old.d4e0271d.svg";